/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DocumentEditContext } from "cms/documents/document-selector/context/document-edit-context";
import { regular } from "cms/icons";
const { faXmark } = regular;
const DocumentEditHeader = () => {
    const { handleEditClose } = useContext(DocumentEditContext);
    return (
        <Fragment>
            <div className="simplicity-doc-selector-window-header">
                <div className="simplicity-doc-selector-window-title doc-edit-title">
                    Edit document
                </div>
                <FontAwesomeIcon
                    className='simplicity-doc-selector-window-close-btn'
                    onClick={handleEditClose}
                    icon={faXmark}
                    size="2xl"
                    style={{ color: "#7A7A7A" }}
                />
            </div>
        </Fragment>
    );
};
export { DocumentEditHeader };
